<template>
    <div>
        <el-form :model="queryParams" ref="queryForm" label-width="80px" size="small" :inline="true" class="demo-form-inline">
            <el-form-item label="开始时间" prop="beginTime" >
                <el-date-picker  clearable v-model="queryParams.beginTime" type="date" value-format="yyyy-MM-dd"
                    placeholder="选择开始时间" :picker-options="pickerStart">
                </el-date-picker>
            </el-form-item>
            <el-form-item label="结束时间" prop="endTime">
                <el-date-picker  clearable v-model="queryParams.endTime" type="date" value-format="yyyy-MM-dd"
                    placeholder="选择结束时间" :picker-options="pickerEnd">
                </el-date-picker>
            </el-form-item>
            <el-form-item label="提单号" prop="blNo">
                <el-input  clearable v-model="queryParams.blNo" placeholder="请输入提单号" style="width: 100%;"></el-input>
            </el-form-item>
            <el-form-item label=" " >
                    <el-button type="primary" @click="getData()" >查询</el-button>
                    <el-button type="warning" @click="exportExcel()" >导出excel</el-button>
            </el-form-item>
        </el-form>
        <!-- 数据 -->
        <el-table  :data="tableData" size="small" style="margin-top: 0px;" ref="report-table">
            <el-table-column type="index" width="50"> </el-table-column>
            <el-table-column prop="deliveryDate" label="送货日期"> </el-table-column>
            <el-table-column prop="startDate" label="开航日期"> </el-table-column>
            <el-table-column prop="shipName" label="船名"> </el-table-column>
            <el-table-column prop="voy" label="航次"> </el-table-column>
            <el-table-column prop="blNo" label="主单号"> </el-table-column>
            <el-table-column prop="port" label="目的港"> </el-table-column>
            <el-table-column prop="containerType" label="柜型"> </el-table-column>
            <el-table-column prop="num" label="数量"> </el-table-column>
            <el-table-column prop="feeName" label="费用名称"> </el-table-column>
            <el-table-column prop="currency" label="币种"> </el-table-column>
            <el-table-column prop="unitPrice" label="单价">
                <template slot-scope="scope">
                    <span v-format="'#,##0.00'">{{ scope.row.unitPrice }}</span>
                </template>
            </el-table-column>
            <el-table-column prop="total" label="总价">
                <template slot-scope="scope">
                    <span v-format="'#,##0.00'">{{ scope.row.total }}</span>
                </template>
            </el-table-column>
            <el-table-column prop="voucherNo" label="客户自编号"> </el-table-column>
        </el-table>
    </div>
</template>

<script>
import req from '@/utils/index.js'
import url from '@/config/url2.js'
import ExcelJS from 'exceljs';
export default {
    data() {
        return {
            queryParams:{
                beginTime:'',
                endTime:'',
                blNo:'',
            },
            tableData:[],
            pickerStart:{
                disabledDate: time => {
                // 如果有 结束 日期 要选择结束之前的日期
                    if(this.queryParams.endTime){
                        return (
                        // 结束日期 小于 开始日期（开始日期不能选择 结束日期之后的日期）
                        new Date(this.queryParams.endTime).getTime() < time.getTime() 
                        );
                    }else{
                        // 如果没有结束日期 那么都可以选
                        return false
                    }
                }
            },
            pickerEnd:{
                disabledDate: time => {
                    // 如果有开始日期 
                    if(this.queryParams.beginTime){
                        return (
                        // 开始日期 必须大于 结束日期（结束日期不能选择开始之前的日期） 
                        // 而 -3600*24*1000 减去 一天的时间可以选择当天日期
                        (
                            (
                            new Date(this.queryParams.beginTime).getTime()
                            )-3600*24*1000
                        )
                        >
                        (time.getTime())
                        );
                    }else{
                        // 如果没有开始日期 都可以选择
                        return false
                    }
                }
            },
        }
    },
     mounted() {
    //    this.getData()
    },
    methods: {
        getData(){
            let URL = `${url.doubleStarReport}`;
            req.post(URL, this.queryParams).then(res => {
                if (res.data.code === 200) {
                    this.tableData = res.data.data;
                }
            })
        },
        async exportExcel(){
            const workbook = new ExcelJS.Workbook();
            const worksheet = workbook.addWorksheet('Sheet1');
            const columns = [
                { header: '送货日期', key: 'deliveryDate', width: 20 },
                { header: '开航日期', key: 'startDate', width: 20 },
                { header: '船名', key: 'shipName', width: 20 },
                { header: '航次', key: 'voy', width: 20 },
                { header: '主单号', key: 'blNo', width: 20 },
                { header: '目的港', key: 'port', width: 20 },
                { header: '柜型', key: 'containerType', width: 20 },
                { header: '数量', key: 'num', width: 20 },
                { header: '费用名称', key: 'feeName', width: 20 },
                { header: '币种', key: 'currency', width: 20 },
                { header: '单价', key: 'unitPrice', width: 20 },
                { header: '总价', key: 'total', width: 20 },
                { header: '客户自编号', key: 'voucherNo', width: 20 },
            ];
              // 设置表头
            worksheet.columns = columns;
             // 添加数据行
            this.tableData.forEach(item => {
                worksheet.addRow(item);
            });

            const buffer = await workbook.xlsx.writeBuffer();
            const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = `${this.getFormattedDateTime()}`;
            link.click();
            window.URL.revokeObjectURL(url);
        },
        getFormattedDateTime() {
            const now = new Date();
            const year = now.getFullYear();
            const month = String(now.getMonth() + 1).padStart(2, '0');
            const day = String(now.getDate()).padStart(2, '0');
            const hours = String(now.getHours()).padStart(2, '0');
            const minutes = String(now.getMinutes()).padStart(2, '0');
            const seconds = String(now.getSeconds()).padStart(2, '0');
            return `${year}-${month}-${day}_${hours}-${minutes}-${seconds}`;
        },
    },
}


</script>